import React from "react";
import { findAllSemesterEvent } from "../../../../../_events/semester/find.event";
import { findFinishFormBySemesterEvent } from "../../../../../_events/form/find.event";
import { alertError } from "../../../../../_utils/alerts";

export const useHistoryForms = () => {

    const [semesters, setSemesters] = React.useState([]);
    const [ data, setData ] = React.useState([]);
    const [ selected, setSelected ] = React.useState('');

    const loadData = (semester) => {
        findFinishFormBySemesterEvent(semester)
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        findAllSemesterEvent()
        .then(json => {
            setSemesters(json.list);
            if (json.list.length > 0) {
                setSelected(json.list[0].cod);
                loadData(json.list[0].cod);
            };
        })
        .catch(err => {
            alertError(err.message);
        });
    }, []);

    return { semesters, setSemesters, selected, setSelected, data, setData, loadData };
}